import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../icon';

// styles
import css from './back.sss';

// images
import BackIconSvg from './images/back.icon.svg';


export const Back = ({ onClick, dataQA, count }) => {
    return (
        <span
            onClick={onClick}
            data-qaid={dataQA}
            className={css.root}
        >
            <Icon glyph={BackIconSvg} />
            {count && (
                <span className={css.indicator} />
            )}
            {/* TODO add unred messages counter
                {if counter > 0 && (
                    <span className={css.counter}>7</span>
                )}
            */}
        </span>
    );
};

Back.propTypes = {
    dataQA: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};
